import { SmartCheckbox } from 'app/components/shared/FormComponents/SmartCheckbox'
import { SmartInput } from 'app/components/shared/FormComponents/SmartInput'
import { FormGroup } from 'app/components/shared/FormGroup'
import { Grid } from 'app/components/ui/Grid'
import { useLocationFields } from 'app/hooks/useLocationFields'
import { Location } from 'EstraSponsor'
import React from 'react'
import { useFormContext } from 'react-hook-form'

type Props = {
  locations: Location[]
}

export const SecondaryAddressFormSection = ({
  locations,
}: Props): JSX.Element => {
  const { watch } = useFormContext()

  const provinceIdWatcher = watch('company_secondary_province_id')
  const fillCompanyWatcher = watch('fill_company_secondary_address')

  const { provinceOptions, cityOptions } = useLocationFields({
    locations,
    selectedProvinceId: provinceIdWatcher,
    provincesOnly: true,
  })

  return (
    <>
      <FormGroup>
        <SmartCheckbox name='fill_company_secondary_address'>
          Usare indirizzo per corrispondenza diverso dalla sede legale
        </SmartCheckbox>
      </FormGroup>
      <></>
      {fillCompanyWatcher && (
        <>
          <Grid cols={[8, 2, 2]}>
            <FormGroup>
              <SmartInput
                label='Indirizzo corrispondenza'
                name='company_secondary_address_street'
                labelRequired
              />
            </FormGroup>
            <FormGroup>
              <SmartInput
                label='Num.'
                name='company_secondary_address_number'
                labelRequired
              />
            </FormGroup>
            <FormGroup>
              <SmartInput
                label='CAP'
                name='company_secondary_postal_code'
                labelRequired
              />
            </FormGroup>
          </Grid>
          <Grid cols={[6, 6]}>
            <FormGroup>
              <SmartInput
                type='select'
                label='Provincia'
                name='company_secondary_province_id'
                labelRequired
                selectCaretSize='small'
              >
                <option value={''}>Seleziona</option>
                {provinceOptions.map((province) => (
                  <option key={province.value} value={province.value}>
                    {province.label}
                  </option>
                ))}
              </SmartInput>
            </FormGroup>

            <FormGroup>
              <SmartInput
                type='select'
                label='Comune'
                name='company_secondary_city_id'
                labelRequired
                selectCaretSize='small'
                disabled={!cityOptions.length}
              >
                <option value={''}>Seleziona</option>
                {cityOptions.map((city) => (
                  <option key={city.value} value={city.value}>
                    {city.label}
                  </option>
                ))}
              </SmartInput>
            </FormGroup>
          </Grid>
        </>
      )}
    </>
  )
}
